import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import './Dashboard.css';

export default function Dashboard() {
  const { user, hasRole } = useAuth();
  const isAdmin = hasRole('admin');

  const cards = [
    { path: 'profile', title: 'Min profil', description: `Inloggad som ${user?.username}`, icon: '👤' },
    { path: 'news', title: 'Nyheter', description: 'Hantera nyheter och aktuella händelser', icon: '📰' },
    { path: 'documents', title: 'Dokument', description: 'Ladda upp och hantera dokument', icon: '📄' },
    { path: 'board', title: 'Styrelse', description: 'Uppdatera styrelseinformation', icon: '👥' },
    { path: 'funktionarer', title: 'Funktionärer', description: 'Övriga funktionärer och revisorer', icon: '🔧' },
    { path: 'contact', title: 'Kontaktuppgifter', description: 'E-postadresser och postadress', icon: '📧' },
    { path: 'matrikel', title: 'Digital Matrikel', description: 'Fastighetsägare och kontaktuppgifter', icon: '🏠' },
    { path: 'pages', title: 'Sidinnehåll', description: 'Redigera sidor och innehåll', icon: '📝' },
    { path: 'users', title: 'Användare', description: 'Hantera användare och behörigheter', icon: '⚙️', highlight: isAdmin, adminOnly: true },
    { path: 'backup', title: 'Säkerhetskopiering', description: 'Exportera och återställ data', icon: '💾', highlight: true, adminOnly: true },
  ];

  const visibleCards = cards.filter(card => !card.adminOnly || isAdmin);

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2 className="dashboard-title">Dashboard</h2>
        <p className="dashboard-subtitle">
          Välj en funktion nedan för att komma igång.
        </p>
      </div>

      <div className="dashboard-grid">
        {visibleCards.map(card => (
          <Link 
            key={card.path}
            to={`/styrelsen/dashboard/${card.path}`} 
            className="dashboard-card-link"
          >
            <DashboardCard 
              title={card.title} 
              description={card.description} 
              icon={card.icon}
              highlight={card.highlight}
            />
          </Link>
        ))}
      </div>
    </div>
  );
}

function DashboardCard({ title, description, icon, highlight = false }) {
  return (
    <div className={`dashboard-card ${highlight ? 'dashboard-card-highlight' : ''}`}>
      <div className="dashboard-card-icon">{icon}</div>
      <h4 className="dashboard-card-title">{title}</h4>
      <p className="dashboard-card-description">{description}</p>
    </div>
  );
}
